import { Component, OnInit } from '@angular/core';
import { MainpageService } from "src/app/services/mainpage.service";
import { AddrequestService } from "src/app/services/addrequest.service";
import { portalgetalldatatable , ScPortalRequest} from "src/app/models/portalgetalldatatable";
import { faPen, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DeletemodalComponent } from 'src/app/components/deletemodal/deletemodal.component';
import { BoardService } from "src/app/services/board.service";
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private MainpageService:MainpageService,
    private AddrequestService:AddrequestService,
    private route: Router,
    private deleteModal:MatDialog,
    private BoardService:BoardService,
    private toastr: ToastrService,
    public translate: TranslateService,
    ) { }

  orders:ScPortalRequest[]=[];
  loadingOverlay = true;
  // Icons
  editIcon=faPen;
  showIcon=faEye;
  deleteIcon=faTrash;
  toastrMsgs:any;

  ngOnInit() {
    debugger
    this.getData();
    this.getToastrMsgs();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  getData(){
    debugger
    this.MainpageService.GetDashboardDataTable()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.orders = data.result.items;
      this.loadingOverlay = false;
      let filterdOrders = this.orders.filter(x=>x.statusLkpId == 149 || x.statusLkpId == 150 || x.statusLkpId == 179 || x.statusLkpId == 158);
      if(filterdOrders.length>0){
        this.MainpageService.SetAddRequestPermissionToSessionStorage(false);
      }else{
        this.MainpageService.SetAddRequestPermissionToSessionStorage(true);
      }
    })
  }

  editRow(id,tenantId){
    debugger
    this.route.navigate(['board/addrequest',id, tenantId])
  }

  viewRow(id,tenantId){  
    this.route.navigate(['board/addrequest',id, tenantId,'view'])
  }

  getToastrMsgs(){
    this.translate.get('ToastrSuccess')
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      this.toastrMsgs = data;
    })
  }

  deleteRow(id,tenantId){
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.maxWidth="350px";
    this.deleteModal.open(DeletemodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        return false
      }else{
        this.loadingOverlay = true;
        this.AddrequestService.DeleteRequest(id,tenantId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data=>{
          this.toastr.success(this.toastrMsgs.delete);
          this.getData();
          this.BoardService.pushNotification()
        },error=>{
          this.toastr.error(error.error.error.message);
        })        
      }
    });

  }

}
